import axios from "axios";
import { Buffer } from "buffer";
import { store } from "../state/store";

let interceptorAdded = false;

function ApiService() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const USERNAME = process.env.REACT_APP_USERNAME;
  const PASSWORD = process.env.REACT_APP_PASSWORD;

  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.post["Content-Type"] = "application/json";
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = false;

  const token = `${USERNAME}:${PASSWORD}`;
  const encodedToken = Buffer.from(token).toString("base64");

  if (!interceptorAdded) {
    axios.interceptors.request.use(function (config) {
      config.headers.Authorization = `Basic ${encodedToken}`;
      return config;
    });
    interceptorAdded = true;
  }

  const pickOrgId = (orgId) =>
    orgId ||
    (store && store.getState && store.getState().organization && store.getState().organization.organizationId) ||
    process.env.REACT_APP_ORG_ID ||
    "";

  const fetchOrgIdByDomainName = (domain) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/domainOrgId/${domain}`);

  const fetchNewsUpdates = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/newsAndNotice/web/${pickOrgId(orgId)}/news`);

  const fetchNoticeUpdates = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/newsAndNotice/web/${pickOrgId(orgId)}/notice`);

  const fetchContact = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/contactList/${pickOrgId(orgId)}`);

  const fetchAboutUs = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/aboutUs/web/${pickOrgId(orgId)}`);

  const fetchSliderImages = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/sliderImages/${pickOrgId(orgId)}`);

  const fetchStaffs = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/staffCommittee/${pickOrgId(orgId)}`);

  const fetchGalleries = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/organizationGallery/web/${pickOrgId(orgId)}`);

  const fetchDownloads = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/organizationDocument/web/${pickOrgId(orgId)}`);

  const fetchMessages = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/messagesFromStaffs/web/${pickOrgId(orgId)}`);

  const fetchPopup = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/popup/web/${pickOrgId(orgId)}`);

  const fetchNewsDetailById = (newsId, orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/newsAndUpdatesById/web/${pickOrgId(orgId)}/${newsId}`);

  const fetchServices = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/ourServices/web/${pickOrgId(orgId)}`);

  const fetchServiceDetailById = (serviceId, orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/ourServicesById/web/${pickOrgId(orgId)}/${serviceId}`);

  const fetchOrganizationDetails = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/v2/sms/fetchOrganizationDetailsWeb/${pickOrgId(orgId)}`);

  const fetchOrgDetail = (orgId) => fetchOrganizationDetails(orgId);

  const fetchScheduleList = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/nrw/wdMasterList/${pickOrgId(orgId)}`);

  const fetchScheduleById = (idParam, orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/nrw/v2/wdScheduleList/${pickOrgId(orgId)}/${idParam}`);

  const fetchOutStanding = (customerNo, orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/outstandingForWebSite/${pickOrgId(orgId)}/${customerNo}`);

  const fetchReadingScheduleList = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/meterReadingSchedule/${pickOrgId(orgId)}`);

  const fetchPaymentGatewayList = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/admin/paymentGateWayURL/${pickOrgId(orgId)}`);

  const fetchComplainTypes = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/complainTypesForWebsite/${pickOrgId(orgId)}`);

  const complainEntry = (data) =>
    axios.post(`/WaterTariffSystem-web/webresources/customer/saveComplainEntry`, data);

  const contactEntry = (data) =>
    axios.post(`/WaterTariffSystem-web/webresources/customer/contactEntry`, data);

  const tariffChecker = (customerTypeId, tapSizeId, fromUnit, toUnit, orgId) =>
    axios.get(
      `WaterTariffSystem-web/webresources/customer/tariffChecker/${pickOrgId(orgId)}/${customerTypeId}/${tapSizeId}/${fromUnit}/${toUnit}`
    );

  const allTariffDetails = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/allTariffDetails/${pickOrgId(orgId)}`);

  const organizationBasicDetail = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/customer/organizationBasicDetail/${pickOrgId(orgId)}`);

  const fetchAccountProfile = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/admin/accountNatureBalance/${pickOrgId(orgId)}`);

  const fetchCustomerCountProfile = (orgId) =>
    axios.get(`WaterTariffSystem-web/webresources/admin/customerCount/${pickOrgId(orgId)}`);

  return {
    fetchNewsUpdates,
    fetchNoticeUpdates,
    fetchContact,
    fetchAboutUs,
    fetchSliderImages,
    fetchStaffs,
    fetchGalleries,
    fetchDownloads,
    fetchMessages,
    fetchPopup,
    fetchNewsDetailById,
    fetchServices,
    fetchOrganizationDetails,
    fetchScheduleList,
    fetchScheduleById,
    fetchOutStanding,
    fetchServiceDetailById,
    fetchReadingScheduleList,
    fetchPaymentGatewayList,
    fetchComplainTypes,
    complainEntry,
    contactEntry,
    tariffChecker,
    allTariffDetails,
    fetchAccountProfile,
    fetchCustomerCountProfile,
    organizationBasicDetail,
    fetchOrgIdByDomainName,
    fetchOrgDetail,
  };
}

export default ApiService;